import script from "./AppointmentPlusForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentPlusForm.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentPlusForm.vue?vue&type=style&index=0&id=23b0f98c&lang=scss"

const __exports__ = script;

export default __exports__